import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const RevenueDataForm = ({ formData, onUpdate }) => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const handleMonthlyRevenueChange = (index, value) => {
    const updatedRevenue = [...(formData?.monthlyRevenue || Array(12)?.fill(''))];
    updatedRevenue[index] = value;
    onUpdate({ monthlyRevenue: updatedRevenue });
  };

  const handleTopProductChange = (index, field, value) => {
    const updatedProducts = [...(formData?.topProducts || [{ name: '', contribution: '' }, { name: '', contribution: '' }, { name: '', contribution: '' }])];
    updatedProducts[index] = { ...updatedProducts?.[index], [field]: value };
    onUpdate({ topProducts: updatedProducts });
  };

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <label className="text-sm font-medium text-foreground">
            Monthly Revenue for Last 12 Months <span className="text-destructive">*</span>
          </label>
          <button
            type="button"
            className="flex items-center gap-2 text-sm text-primary hover:text-primary/80 transition-smooth"
          >
            <Icon name="Upload" size={16} color="currentColor" />
            Upload Excel
          </button>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {months?.map((month, index) => (
            <Input
              key={month}
              label={month}
              type="number"
              placeholder="₹0"
              value={formData?.monthlyRevenue?.[index] || ''}
              onChange={(e) => handleMonthlyRevenueChange(index, e?.target?.value)}
            />
          ))}
        </div>
      </div>

      <Input
        label="Average Monthly Growth % (Optional)"
        type="number"
        placeholder="e.g., 5.5"
        value={formData?.averageGrowth || ''}
        onChange={(e) => onUpdate({ averageGrowth: e?.target?.value })}
      />

      <div className="space-y-4">
        <label className="text-sm font-medium text-foreground">
          Top 3 Revenue-Generating Services/Products <span className="text-destructive">*</span>
        </label>
        {[0, 1, 2]?.map((index) => (
          <div key={index} className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-muted/50 rounded-md">
            <Input
              label={`Product/Service ${index + 1} Name`}
              type="text"
              placeholder="Enter name"
              value={formData?.topProducts?.[index]?.name || ''}
              onChange={(e) => handleTopProductChange(index, 'name', e?.target?.value)}
            />
            <Input
              label="Revenue Contribution %"
              type="number"
              placeholder="e.g., 35"
              value={formData?.topProducts?.[index]?.contribution || ''}
              onChange={(e) => handleTopProductChange(index, 'contribution', e?.target?.value)}
            />
          </div>
        ))}
      </div>

      <div className="space-y-4 p-4 bg-accent/10 rounded-md border border-accent/20">
        <label className="text-sm font-medium text-foreground">
          Any Unusual Revenue Spike or Drop? (Optional)
        </label>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Month"
            type="text"
            placeholder="e.g., March 2025"
            value={formData?.revenueSpike?.month || ''}
            onChange={(e) => onUpdate({ revenueSpike: { ...formData?.revenueSpike, month: e?.target?.value } })}
          />
          <Input
            label="Reason"
            type="text"
            placeholder="e.g., Major client contract"
            value={formData?.revenueSpike?.reason || ''}
            onChange={(e) => onUpdate({ revenueSpike: { ...formData?.revenueSpike, reason: e?.target?.value } })}
          />
        </div>
      </div>
    </div>
  );
};

export default RevenueDataForm;